var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8666 1.39999L5.24665 3.05999C4.27998 3.29999 3.29998 4.27999 3.05998 5.24666L1.39998 11.8667C0.89998 13.8667 2.12665 15.1 4.13331 14.6L10.7533 12.9467C11.7133 12.7067 12.7 11.72 12.94 10.76L14.6 4.13332C15.1 2.13332 13.8666 0.899991 11.8666 1.39999Z",
    stroke: "#666D80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 10.3333C9.28862 10.3333 10.3333 9.28865 10.3333 7.99999C10.3333 6.71133 9.28862 5.66666 7.99996 5.66666C6.71129 5.66666 5.66663 6.71133 5.66663 7.99999C5.66663 9.28865 6.71129 10.3333 7.99996 10.3333Z",
    stroke: "#666D80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.fa7aca3d9aef7292037e45184c0e6b15.svg";
export { ForwardRef as ReactComponent };